export const NEED_CAPTURE_INTRO_ENABLED = 'settings.needCapture.intro.enabled';
export const NEED_CAPTURE_WIZARD_ENABLED = 'settings.needCapture.fragranceProfile.wizard.enabled';